<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="players"
      :chart-value-keys="[{ key: 'RMSSD', label: 'RMSSD', type: 'line' }, { key: 'SDNN', label: 'SDNN', type: 'bar' } ]"
      x-value="last_name"
      y-value-prefix="player_stats."
      :yaxis="[ { title: { text: 'RMSSD' }}, { title: { text: 'SDNN' }, opposite: true} ]"
      :xaxis="{
        labels: {
          rotate: -45
        },
        categories: players.map(p => p.first_name[0] + '. ' + p.last_name ),
        tickPlacement: 'between'
      }"
      :colors="[ '#00E396', '#008FFB' ]"
      :fill="{ opacity: [1, 1]}"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            RMSSD
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          RMSSD
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <v-data-table
        :headers="tableHeaders"
        :items="players"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        fixed-header
        dense
        :height="350"
      >
        <template v-slot:item.last_name="{ item }">
          {{ item.last_name }}, {{ item.first_name }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'

export default {
  name: 'SdnnRmssdChart',
  components: { LineChart, VisualListToggle },
  props: {
    players: {
      type: Array,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    tableHeaders() {
      return [
        {
          text: this.$t('table_headers.name'),
          value: 'last_name',
          sortable: true,
          width: '40%'
        },
        {
          text: 'RMSSD',
          value: 'player_stats.RMSSD',
          sortable: true,
          align: 'center'
        },
        {
          text: 'SDNN',
          value: 'player_stats.SDNN',
          sortable: true,
          align: 'center'
        }
      ]
    }
  }
}
</script>
